import { render, staticRenderFns } from "./media-preview-AUDIO.vue?vue&type=template&id=0c2105b3&"
import script from "./media-preview-AUDIO.vue?vue&type=script&lang=js&"
export * from "./media-preview-AUDIO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c2105b3')) {
      api.createRecord('0c2105b3', component.options)
    } else {
      api.reload('0c2105b3', component.options)
    }
    module.hot.accept("./media-preview-AUDIO.vue?vue&type=template&id=0c2105b3&", function () {
      api.rerender('0c2105b3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/media-file-preview/types/media-preview-AUDIO.vue"
export default component.exports